import { useState, useMemo } from "react";
import { Puzzle } from "lucide-react";
import { toast } from "sonner";
import { MODULES } from "../../data/adminData";
import { PageTitle, Badge, Btn } from "./ui";

export default function Modules() {
  const [list, setList] = useState(MODULES);
  const [cat, setCat] = useState("Visi");
  const cats = useMemo(() => ["Visi", ...new Set(MODULES.map((m) => m.cat))], []);
  const shown = list.filter((m) => cat === "Visi" || m.cat === cat);

  const install = (id) => {
    setList((p) => p.map((m) => (m.id === id ? { ...m, installed: true, enabled: true } : m)));
    toast.success("Modulis instalēts un aktivizēts (DEMO)");
  };
  const toggle = (id) => {
    setList((p) => p.map((m) => (m.id === id ? { ...m, enabled: !m.enabled } : m)));
    toast.success("Moduļa statuss mainīts (DEMO)");
  };

  return (
    <div data-testid="admin-modules">
      <PageTitle>Moduļi ({list.filter((m) => m.installed).length} instalēti / {list.length})</PageTitle>
      <div className="flex gap-2 flex-wrap mb-5">
        {cats.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`module-cat-${c}`}
            className={`text-xs font-bold uppercase tracking-wider px-3 py-1.5 border transition-colors ${cat === c ? "bg-[#111111] text-white border-[#111111]" : "border-[#E2E2E2] hover:border-[#111111] bg-white"}`}>{c}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {shown.map((m) => (
          <div key={m.id} className="bg-white border border-[#E2E2E2] p-5 flex flex-col" data-testid={`module-card-${m.id}`}>
            <div className="flex items-start justify-between mb-3">
              <span className="w-10 h-10 bg-[#F5F5F5] flex items-center justify-center"><Puzzle size={18} className="text-[#D0121A]" /></span>
              {m.installed
                ? <Badge color={m.enabled ? "green" : "gray"}>{m.enabled ? "Aktīvs" : "Izslēgts"}</Badge>
                : <Badge color="black">Pieejams</Badge>}
            </div>
            <div className="text-sm font-bold">{m.name}</div>
            <div className="text-[11px] uppercase tracking-wider text-[#6B6B6B] mt-0.5">{m.cat}</div>
            <div className="text-xs text-[#6B6B6B] mt-2 flex-1">{m.desc}</div>
            <div className="mt-4">
              {m.installed
                ? <Btn variant="outline" onClick={() => toggle(m.id)} data-testid={`module-toggle-${m.id}`} className="w-full">{m.enabled ? "Izslēgt" : "Ieslēgt"}</Btn>
                : <Btn variant="red" onClick={() => install(m.id)} data-testid={`module-install-${m.id}`} className="w-full">Instalēt</Btn>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
